import { map, takeUntil } from 'rxjs/operators';
import { Component, Input } from '@angular/core';

import { DestroyerBase } from '@core/base/destroyer/destroyer.base';
import { ModalsService } from '@core/services/modals/modals.service';
import { ModalStoreSelector } from '@common/selectors/modal.selector';
import { GetModalInterface, ModalConfig } from '@core/services/modals/modals-util.type';

export type ShareUserFeedbackModalConfig = ModalConfig<{
  handle: 'share-user-feedback';
  inputs: {
    title?: string;
    description?: string;
    // items are retrieved from the content builder
  };
}>;

@Component({
  selector: 'app-share-user-feedback-modal',
  templateUrl: './share-user-feedback-modal.component.html',
  styleUrls: ['./share-user-feedback-modal.component.scss'],
  standalone: false,
})
export class ShareUserFeedbackModalComponent
  extends DestroyerBase
  implements GetModalInterface<ShareUserFeedbackModalConfig>
{
  static handle = 'share-user-feedback' as const;

  index = 0;

  @Input() title = '';
  @Input() description = '';
  @Input() items: unknown[] = [];

  constructor(
    private modalService: ModalsService<ShareUserFeedbackModalConfig>,
    private modalSelector: ModalStoreSelector,
  ) {
    super();
    this.modalSelector
      .selectModal(ShareUserFeedbackModalComponent.handle)
      .pipe(
        takeUntil(this._destroyerRef),
        map(el => (el?.index ? el.index : 4)),
      )
      .subscribe(_index => {
        this.index = _index;
      });
  }

  closeModal(_event: Event): void {
    this.modalService.close(ShareUserFeedbackModalComponent.handle);
  }
}
